/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1-alpha  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1-alpha
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ユーザーに対する話の閲覧権限を表します。
 * @export
 * @interface EpisodeAccess
 */
export interface EpisodeAccess {
    /**
     * 話のID
     * @type {string}
     * @memberof EpisodeAccess
     */
    episodeId: string;
    /**
     * trueの場合は閲覧可能
     * @type {boolean}
     * @memberof EpisodeAccess
     */
    hasAccess: boolean;
    /**
     * trueの場合はボーナスポイントの利用不可能
     * @type {boolean}
     * @memberof EpisodeAccess
     */
    isDisableBonusCoin?: boolean;
    /**
     * 閲覧可否理由
     * * free: 無料
     * * paidContent: 有料コンテンツ
     * * purchased: 購入済み
     * * waitAndFree: 待つと無料
     * * trial: 無料試し読み
     * @type {string}
     * @memberof EpisodeAccess
     */
    accessType: EpisodeAccessAccessTypeEnum;
    /**
     * 閲覧期限が設定されている場合は、このフィールドに残り時間(秒数)が設定されます。
     * @type {number}
     * @memberof EpisodeAccess
     */
    timeRemainingInSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof EpisodeAccess
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof EpisodeAccess
     */
    priceUnit?: string;
    /**
     * trueの場合、この話をすでに閲覧したことを示します。
     * @type {boolean}
     * @memberof EpisodeAccess
     */
    read: boolean;
}


/**
 * @export
 */
export const EpisodeAccessAccessTypeEnum = {
    Purchased: 'purchased',
    WaitAndFree: 'waitAndFree',
    Trial: 'trial',
    Free: 'free',
    PaidContent: 'paidContent'
} as const;
export type EpisodeAccessAccessTypeEnum = typeof EpisodeAccessAccessTypeEnum[keyof typeof EpisodeAccessAccessTypeEnum];


/**
 * Check if a given object implements the EpisodeAccess interface.
 */
export function instanceOfEpisodeAccess(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "episodeId" in value;
    isInstance = isInstance && "hasAccess" in value;
    isInstance = isInstance && "accessType" in value;
    isInstance = isInstance && "read" in value;

    return isInstance;
}

export function EpisodeAccessFromJSON(json: any): EpisodeAccess {
    return EpisodeAccessFromJSONTyped(json, false);
}

export function EpisodeAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpisodeAccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'episodeId': json['episodeId'],
        'hasAccess': json['hasAccess'],
        'isDisableBonusCoin': !exists(json, 'isDisableBonusCoin') ? undefined : json['isDisableBonusCoin'],
        'accessType': json['accessType'],
        'timeRemainingInSeconds': !exists(json, 'timeRemainingInSeconds') ? undefined : json['timeRemainingInSeconds'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'priceUnit': !exists(json, 'priceUnit') ? undefined : json['priceUnit'],
        'read': json['read'],
    };
}

export function EpisodeAccessToJSON(value?: EpisodeAccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'episodeId': value.episodeId,
        'hasAccess': value.hasAccess,
        'isDisableBonusCoin': value.isDisableBonusCoin,
        'accessType': value.accessType,
        'timeRemainingInSeconds': value.timeRemainingInSeconds,
        'price': value.price,
        'priceUnit': value.priceUnit,
        'read': value.read,
    };
}

